import { useRef, useState } from "react";
import parse from "html-react-parser";
import Icon from "../../Elements/Icon/Icon.tsx";
import SideBarContentHolder from "../../Reusable/SideBar/SideBarContentHolder.js";
import ReportButton from "../../Reusable/Report/ReportButton.js";
import GetTransformedDate from "../../../utils/dateViewTransformer.tsx";
import bytesToDisplayHelper from "../../../utils/bytesToDisplayHelper.js";
import useMailSender from "../../../hooks/useMailSender.js";
import SaveMailButton from "../SaveMail/saveMailButton.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import DownloadLogModal from "./DownloadLogModal.js";
import MailRecipientsComponent from "../../Pages/Inbox/Mails/MailRecipientsComponent.js";
import CustomPopup from "components/Pages/Inbox/Popups/CustomPopup.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { decode } from "html-entities";
import { useModal } from "../../../contexts/modalContext/modalContext.js";

// const DownloadLogElement = ({ logRef }) => {
//   const { isLoggedIn, getUserData } = useUser();
//   const { getMailId } = useMail();
//   const [logList, setLogList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { setModal } = useModal();

//   const getLogList = async () => {
//     setLoading(true);
//     const response = await apiRequest(
//       "Mails",
//       "ReactGetDownloadLog",
//       { encryptedMailId: getMailId() },
//       "GET"
//     );

//     if (response.status === "success") {
//       const sortedResponse = response.data.sort((a, b) => {
//         const dateA = new Date(a.Date);
//         const dateB = new Date(b.Date);
//         return dateB - dateA;
//       });
//       setLogList(sortedResponse);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     if (getMailId()) {
//       getLogList();
//     }
//   }, [getMailId()]);

//   const openDownloadLogs = () => {
//     setModal({
//       modal: DownloadLogModal,
//     });
//   };

//   return (
//     <div className="logs-list-container" ref={logRef}>
//       {loading ? (
//         <div className="loader-container">
//           <LoadingImageElement />
//         </div>
//       ) : (
//         <>
//           {logList.slice(0, 5).map((item) => {
//             return (
//               <div className="log-element" key={item.Date}>
//                 <div className="log-time">
//                   <GetTransformedDate date={item.Date} showTime={true} />
//                 </div>
//                 <div className="log-user">{item.UserName || "anonymous"}</div>
//               </div>
//             );
//           })}
//         </>
//       )}
//     </div>
//   );
// };

const InfoInnerComponent = () => {
  const { getMailMetaData, getSender, isMailAvailable } = useMail();
  const { getTextByKey } = useContent();
  const { isMailSender } = useMailSender();
  const metaData = getMailMetaData() || {};

  const size = bytesToDisplayHelper(metaData.TotalSize);
  const { setModal } = useModal();

  const [showLog, setShowLog] = useState(false);

  const openDownloadLogs = () => {
    setModal({
      modal: DownloadLogModal,
    });
  };

  const RowElement = ({ children, title }) => {
    return (
      <div className="row side-bar-row">
        <div className="col-5 sidebar-row-title">{getTextByKey(title)}</div>
        <div className="col-7 sidebar-row-value">{children}</div>
      </div>
    );
  };

  const handleShowLog = () => {
    setShowLog((prev) => !prev);
  };

  const logRef = useRef();

  const uniqueDownloadCount = metaData.UniqueDownloadCount;
  const totalDownloadCount = metaData.DownloadsCount;

  const logsText = `${
    uniqueDownloadCount
      ? `${getTextByKey(
          "mail-unique-downloads-logs-text"
        )} ${uniqueDownloadCount} <br>`
      : ""
  }${getTextByKey("mail-total-downloads-logs-text")} ${totalDownloadCount}`;

  useOnClickOutside(logRef, () => setShowLog(false));
  return (
    <>
      {" "}
      <div className="info-header">
        <Icon name="folder" gray xl />
        <span>{decode(metaData.subjectText)}</span>
      </div>
      <RowElement title={getTextByKey("sidebar-info-from")}>
        {getSender().name?.trim().length > 0
          ? getSender().name
          : getSender().email}
      </RowElement>
      <RowElement title={getTextByKey("sidebar-info-subject")}>
        {decode(metaData.subjectText)}
      </RowElement>
      <RowElement title={getTextByKey("sidebar-info-creationdate")}>
        <GetTransformedDate date={metaData.Creation} />
      </RowElement>
      <RowElement
        title={getTextByKey(
          metaData.RemovalDate ? "expiry-date" : "sidebar-info-expirationdate"
        )}
      >
        <GetTransformedDate
          date={
            metaData.RemovalDate ? metaData.RemovalDate : metaData.Expiration
          }
        />
      </RowElement>
      <RowElement title={getTextByKey("sidebar-info-downloads")}>
        <div className="download-log-container">
          {metaData.UniqueDownloadCount || metaData.DownloadsCount}
          {isMailSender() && metaData.DownloadsCount > 0 ? (
            <div className="download-log" onClick={() => openDownloadLogs()}>
              <Tooltip tooltipText={parse(logsText)} className="download-log">
                {getTextByKey("view-log-text")}
              </Tooltip>
              {/* <Icon name="arrow-down-solid" /> */}
            </div>
          ) : null}
        </div>
        {/* <AnimationContainer animationOn={showLog} animationClassName="fade-in">
          <DownloadLogElement logRef={logRef} /> 
           <DownloadLogModal/>
        </AnimationContainer> */}
      </RowElement>
      {isMailSender() ? (
        <RowElement title={getTextByKey("sidebar-info-recipients")}>
          <MailRecipientsComponent recipientsList={metaData.RecipientsList} />
        </RowElement>
      ) : null}
      <RowElement title={getTextByKey("sidebar-info-files")}>
        {metaData.filesCount}
      </RowElement>
      {metaData.expectedFilesCount &&
      metaData.expectedFilesCount !== metaData.filesCount &&
      metaData.errorFilesList ? (
        <>
          <RowElement title={getTextByKey("sidebar-info-expected-files")}>
            {metaData.expectedFilesCount}
          </RowElement>
          <RowElement
            title={getTextByKey("sidebar-info-missing-files")}
            ref={logRef}
          >
            <div onClick={handleShowLog} className="error-files-log">
              {getTextByKey("upload-complete-show")}
            </div>
            <CustomPopup showState={showLog} topPosition={30}>
              <div className="full-recipents-list">
                <div className="right-side">
                  {metaData.errorFilesList?.map((item, i) => {
                    const size = bytesToDisplayHelper(item.size);
                    return (
                      <div className="mail-adress" key={item.name}>
                        {item.name} ({size.size + size.type})
                      </div>
                    );
                  })}
                </div>
              </div>
            </CustomPopup>
          </RowElement>
        </>
      ) : null}
      <RowElement title={getTextByKey("sidebar-info-size")}>
        {size.size} {size.type}
      </RowElement>
      {metaData.DownloadsCount > 50 ? (
        <RowElement title={getTextByKey("sidebar-info-removedate")}>
          {!metaData.IsSaved ? (
            <div>
              <GetTransformedDate date={metaData.Expiration} fullView={false} />
            </div>
          ) : (
            <div>{getTextByKey("mail-has-no-expiration-text")}</div>
          )}
          {isMailSender() && isMailAvailable() ? (
            <SaveMailButton showAsText />
          ) : (
            <></>
          )}
        </RowElement>
      ) : null}
      <div className="horizontal-divider"></div>
      <ReportButton />
    </>
  );
};

const InfoActionComponent = ({
  itemId,
  lightBox,
  iconName,
  tooltipDisabled,
}) => {
  const { setSideBar } = useSideBar();
  const { getTextByKey } = useContent();

  const handleClick = () => {
    setSideBar(
      <SideBarContentHolder
        headerName={getTextByKey("sidebar-info-header")}
        headerIcon={"info"}
      >
        <InfoInnerComponent />
      </SideBarContentHolder>,
      itemId,
      lightBox
    );
  };
  return !tooltipDisabled ? (
    <Tooltip id={"infoActionIcon"} tooltipTextKey="info-icon-tooltip-text">
      <Icon name={iconName || "info"} onClick={handleClick} gray clickable />
    </Tooltip>
  ) : (
    <Icon name={iconName || "info"} onClick={handleClick} gray clickable />
  );
};

export default InfoActionComponent;
